import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-down-icon',
  standalone: true,
  templateUrl: './chevron-down-icon.component.html',
})
export class ChevronDownIconComponent {}
